export class DocPrix {

	public devise: string;

	public value: number;

	constructor() { 
		 		this.devise = '';
		this.value = 0;
 
	}
}
